import {
  Card,
  CardHeader,
  CardTitle,
  CardContent,
} from "../../../components/ui/card";
import { Button } from "../../../components/ui/button";
import Table2 from "../../../components/table/table-2";
import FormRenderer from "../../../components/input-field/form-renderer";
import { createRoleFields } from "../../../config/role/create-role";
import { isFormValid } from "../../../utils/validators";
import { useState } from "react";
import { columns, data } from "../../../data/admin/role/create-role";
import { createRole, getRolesById } from "../../../services/admin/role-service";
import { showErrorToast, showSuccessToast } from "../../../utils/toast-utils";
import Loader from "../../../components/loader/loader";
import { Check, X } from "lucide-react";
import { useGetAllRoles } from "../../../hook/admin/use-role";
import ViewRolesDataByID from "../../../components/viewsModals/viewRolesDataByID";
const CreateRole = () => {
  const [form, setForm] = useState({});
  const [createRoleResponse, setCreateRoleResponse] = useState(null);
  const [loading, setLoading] = useState(false);
  const [closeMessage, setCloseMessage] = useState(false);
  const [viewRolesdata, setViewRolesData] = useState(null);
  const [rolesDataLoading, setRolesDataLoading] = useState(false);

  const roleColumns = [
    {
      key: "index",
      label: "S.No",
      render: (_, index) => index + 1,
    },

    {
      key: "roleName",
      label: "Role Name",
    },
    {
      key: "prefix",
      label: "Prefix",
    },
    {
      key: "roleDescription",
      label: "Role Description",
    },

    {
      label: "Actions",
      key: "actions",
      render: (row) => (
        <div className="flex gap-2">
          <button
            onClick={() => handleView(row.id)}
            className="px-2 py-1 text-xs bg-blue-100 text-blue-600 rounded hover:bg-blue-200"
          >
            View
          </button>
        </div>
      ),
    },

    {
      key: "isActive",
      label: "Status",
      render: (row) => (
        <span
          className={`px-2 py-1 rounded-full text-xs font-semibold ${
            row.isActive === 1
              ? "bg-green-100 text-green-600"
              : "bg-red-100 text-red-600"
          }`}
        >
          {row.isActive ? "Active" : "Inactive"}
        </span>
      ),
    },
  ];

  const handleView = async (id) => {
    if (!id) return;

    setRolesDataLoading(true);

    try {
      const res = await getRolesById({ role_id: id });
      console.log(res);
      setViewRolesData(res);
    } catch (error) {
      console.log(error);
    } finally {
      setRolesDataLoading(false);
    }
  };

  const { data: roles = [], isLoading: rolesLoading, refetch: rolesRefetch } = useGetAllRoles();

  const handleCreateRole = async () => {
    setLoading(true);
    try {
      const res = await createRole({
        name: form.roleName.replace(/\s+/g, "-").toLowerCase(),
        prefix: form.prefix,
        description: form.roleDescription,
      });

      if (res) {
        setCreateRoleResponse(res.data);
        console.log(res);
      }

      if (res?.data?.status === 201) {
        showSuccessToast(res.data?.message);
        rolesRefetch()
      } else {
        showErrorToast(res?.data?.message || res?.data?.data?.message || res?.message);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="">
      {(loading || rolesDataLoading) && <Loader />}

      <h2 className="text-2xl md:text-3xl text-gray-900 font-semibold mb-3 md:mb-8">
        Create Role
      </h2>
      <div className="grid grid-cols-1 gap-6">
        <Card className="border-none shadow-md bg-white">
          <div className="w-full p-2 md:p-4">
            <FormRenderer
              fields={createRoleFields}
              values={form}
              setValues={setForm}
            />
          </div>
          <Button
            disabled={!isFormValid(createRoleFields, form)}
            onClick={handleCreateRole}
            variant="admin.secondary"
            className="ml-6 mb-6"
          >
            Submit
          </Button>
        </Card>

        {createRoleResponse?.status === 201 && !closeMessage && (
          <div className="mt-4 flex items-center justify-between gap-3 rounded-xl border border-green-200 bg-green-50 px-4 py-3 shadow-sm animate-fade-in">
            <div className="flex justify-center items-center gap-4">
              <div className="flex h-8 w-8 items-center justify-center rounded-full bg-green-100">
                <Check className="h-5 w-5 text-green-600" />
              </div>

              <div className="flex flex-col">
                <p className="text-sm font-semibold text-green-700">Success</p>
                <p className="text-sm text-green-600">
                  {createRoleResponse?.message ||
                    createRoleResponse?.data?.message ||
                    "Patient Created Successfully"}
                </p>
              </div>
            </div>

            <button onClick={() => setCloseMessage(true)} className="">
              <X />
            </button>
          </div>
        )}

        {/* show data by id if clicked on view */}

        {viewRolesdata && (
          <ViewRolesDataByID
            viewRolesdata={viewRolesdata?.data?.data}
            setViewRolesData={setViewRolesData}
          />
        )}

        <Card className="border-none shadow-md bg-white">
          <CardHeader>
            <CardTitle className="text-md md:text-xl text-gray-600">
              Role List
            </CardTitle>
          </CardHeader>
          <CardContent className="pl-4 text-[#081a3a] text-2xl md:text-4xl font-bold">
            <Table2 columns={roleColumns} data={roles} rowsPerPage={3} />
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default CreateRole;
